import * as React from 'react';
import { ReactElement, useCallback, useState } from 'react';
import './select-input.css';
import FileSelectButton from '../file-select-button';
import { Parameter } from 'shapediver-types';
import { blobToDataURI } from '../../utils';

type ParameterDefinition = Parameter.ParameterDefinition & {
  format?: string[];
};

type Props = {
  label?: string;
  definition: ParameterDefinition;
  onChange: (newValue: string) => void;
};

const FileInput = (props: Props): ReactElement | null => {
  const { definition, label, onChange } = props;
  const { id, name } = definition;

  const [fileName, setFileName] = useState('');

  const onFileChange = useCallback(
    (files: FileList | null): void => {
      if (!files || files.length === 0) return;

      const file = files[0];
      setFileName(file.name);

      blobToDataURI(file).then(onChange);
    },
    [onChange, setFileName]
  );

  const format = definition.format;
  const accept = format && format.length > 0 ? format.join(',') : undefined;

  return (
    <>
      <FileSelectButton
        id={String(id)}
        label={label || name || 'Select File'}
        accept={accept}
        onChange={onFileChange}
      />

      {fileName && <div>{fileName}</div>}
    </>
  );
};

export default FileInput;
